import { EMediaQuery } from '@NGUtils/enums';
import { mq, mqRange } from '@NGUtils/functions';
import { TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

export const TransitionGroupEx = styled(TransitionGroup)(
	({ theme }) => `
    position: fixed;
    top: calc(70px + ${theme.spacing['2xs']});
    right: ${theme.spacing.s};
    width: 299px;
    z-index: 910;

    ${mq(
			EMediaQuery.sm,
			`
        right: unset;
        left: 50%;
        transform: translateX(-50%);
        width: 85%;
      `
		)}

    ${mqRange(EMediaQuery.sm, EMediaQuery.lg, 'left: unset;')}

    ${mq(EMediaQuery.md, `top: calc(52px + ${theme.spacing.xs});`)}
  `
);
